import React, { Component } from 'react';
import { connect } from 'react-redux';
import myPrivilegesCardViewRegistry from '../../../../registries/MyPrivilegesCardViewRegistry';
import './styles.scss';

export interface MyPrivilegesDetailsViewProps {
  Comp: any;
  myPrivilegesId: string;
  cardViewId: string;
}

export interface MyPrivilegesDetailsViewState {}

export class MyPrivilegesDetailsView extends Component<
  MyPrivilegesDetailsViewProps,
  MyPrivilegesDetailsViewState
> {
  constructor(props: any = {}) {
    super(props);
  }

  componentDidMount() {}

  render() {
    const { Comp } = this.props;
    return Comp;
  }

  static mapStateToProps(state: any, ownProps: any) {
    const { myPrivilegesId, cardViewId } = ownProps;
    const Comp = myPrivilegesCardViewRegistry.renderDetailsView(
      myPrivilegesId ? myPrivilegesId : '',
      cardViewId,
    );
    return {
      Comp,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  MyPrivilegesDetailsView.mapStateToProps,
  MyPrivilegesDetailsView.mapDispatchToProps,
)(MyPrivilegesDetailsView);
